import React, { Component } from "react";
import { Accessor, ZTime } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class ZIdleTimer extends Component {

  static propTypes = {
    onIdle: PropsType.func,
    onAwake: PropsType.func
  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      isIdle: false
    };
  }

  componentDidMount(){
    window.addEventListener("mousemove", this._active);
    window.addEventListener("keydown", this._active);
    this._active();
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ZIdleTimer.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("mousemove", this._active);
    window.removeEventListener("keydown", this._active);
    clearTimeout(this.timeout);
    this.setState = (state, callback) => {
      return;
    };
  }

  shouldComponentUpdate(nextProps, nextState){
    let propIdentical = Accessor.IsIdentical(nextProps, this.props, Object.keys(ZIdleTimer.defaultProps));
    let stateIdentical = Accessor.IsIdentical(nextState, this.state, null);
    if(propIdentical && stateIdentical){
      return false;
    }
    return true;
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _active = () => {
    let {onAwake} = this.props;
    let {isIdle} = this.state;
    if(isIdle){
      this.setState({
        isIdle: false
      }, onAwake);
    }
    this.lastUpdated = ZTime.Now().toISOString();
    clearTimeout(this.timeout);
    this.timeout = setTimeout(this._idle, SysConfig.IdleTime * 1000);
  }

  _idle = () => {
    let {onIdle} = this.props;
    clearTimeout(this.timeout);
    this.setState({
      isIdle: true
    }, onIdle);
  }

  render(){
    return (
      <div/>
    );
  }

}

export default ZIdleTimer;
